// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__1Mu6k","label":"Completed_label__2KXj2"};